import Vue from 'vue'

export default {
  getBilling () {
    return Vue.api.get('engine/billing').then((res) => res.data)
  },
  getBillingCustomer () {
    return Vue.api.get('engine/billing/customer').then((res) => res.data)
  },
  getBillingCosts ({ commit }) {
    return Vue.api.get('engine/billing/costs').then((res) => commit('init', { costs: res.data }))
  },
  getBillingHistory (context, page) {
    return Vue.api.get('engine/billing/history/' + page).then((res) => res.data)
  },
  updateBillingCustomer (context, data) {
    return Vue.api.put('engine/billing/customer', data)
      .then((res) => res.data)
  },
  updateBillingProduct ({ commit }, data) {
    return Vue.api.put('engine/billing/product', data)
      .then((res) => commit('init', { client: res.data }))
  },
  createPaymentMethod ({ commit, dispatch }, data) {
    return Vue.api.post('engine/billing/payment-method', data).then((res) => res.data)
  },
  savePaymentMethod ({ commit }, data) {
    return Vue.api.put('engine/billing/payment-method', data)
      .then((res) => commit('init', { client: res.data }))
  },
  removePaymentMethod ({ commit }, id) {
    return Vue.api.delete('engine/billing/payment-method/' + id)
  }
}
